<template>
    <div class="page" :class="{ 'with-drawer': is_history_resupply_modal_open }">
        <div class="page-content" id="modalBodyPrint">
            <div class="print-header show-print" style="display: none">
                <div style="display: flex; align-items: center; margin-bottom: 20px">
                    <img :src="whitelabel
                            ? whitelabel.data.imgs.img_logo
                            : require('@/assets/Logo-clube-hd.png')
                        " style="width: 135px; height: 70px; margin-right: 25px" alt="Logo" class="show-print" />
                    <div style="flex: 1">
                        <h2 style="margin: 0; font-size: 24px; font-weight: bold">
                            Produtos da Requisição: {{ quotationNumber }}
                        </h2>
                        <div style="font-size: 18px; margin-top: 5px">
                            {{ item.nomeSolicitacao || "Loja não especificada" }}
                        </div>
                        <div style="font-size: 14px; color: #666; margin-top: 5px">
                            Data: {{ new Date().toLocaleDateString("pt-BR") }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-route-select not-print">
                <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
                    Home
                </router-link>
                <span class="material-icons page-route-select-icon">play_arrow</span>
                <div class="page-route-select-text">Produtos do Ressuprimento</div>
            </div>
            <div class="page-header not-print">
                <div class="page-title">
                    Produtos do Ressuprimento <span class="quotation">{{ quotationNumber }}</span>
                    <span class="save-status-indicator">
                        <span v-if="savingStatus === 'idle'" class="material-symbols-outlined">
                            cloud_done
                        </span>
                        <span v-if="savingStatus === 'saving'" class="material-symbols-outlined saving-spin">
                            autorenew
                        </span>
                        <span v-if="savingStatus === 'saved'" class="material-symbols-outlined">
                            cloud_done
                        </span>
                        <span class="save-status-text">
                            {{
                                savingStatus === "idle"
                                    ? ""
                                    : savingStatus === "saving"
                                        ? "Salvando…"
                            : "Alterações salvas!"
                            }}
                        </span>
                    </span>
                </div>
                <div class="page-header-action">
                    <span class="material-symbols-outlined" @click="goBack" title="voltar">
                        arrow_left_alt
                    </span>
                    <span class="material-symbols-outlined" @click="downloadExcel" title="Exportar Excel">
                        table_view
                    </span>
                    <span class="material-symbols-outlined" @click="exportProducts" title="Exportar Txt">
                        description
                    </span>
                    <span @click="download_pdf" class="material-symbols-outlined" title="Exportar PDF"> print </span>
                    <a id="download-pdf" style="display: none"></a>
                </div>
            </div>
            <div v-if="loading" class="loading">Carregando produtos...</div>
            <div v-else class="page-content">
                <div class="page-name-actions not-print">
                    <div style="display:flex; flex-direction: row; gap: 8px; align-items: center">
                        <div class="info-tag edit-name" @click="editName()">
                            <span class="info-tag-label">Requisição</span>
                            <span title="Editar" class="material-symbols-outlined info-tag-icon"> edit </span>
                            <template v-if="!editing">
                                <span class="info-tag-value">{{ item.nomeSolicitacao ? item.nomeSolicitacao : "Nome da Empresa" }}</span>
                            </template>
                            <template v-else>
                                <input v-on:keyup.enter="save_title" id="editNameInput" class="edit-request-name-input"
                                    v-model="item.nomeSolicitacao" :placeholder="item.nomeSolicitacao
                                            ? item.nomeSolicitacao
                                            : 'Digite o nome da requisição'
                                        " @click.stop />
                                <span @click.stop="save_title" title="Salvar"
                                    class="material-icons edit-request-name-icon">save</span>
                            </template>
                        </div>
                        <div class="info-tag">
                            <span class="info-tag-label">Empresa</span>
                            <span class="material-symbols-outlined info-tag-icon">store</span>
                            <span class="info-tag-value">{{ item.nomeLoja }}</span>
                        </div>
                    </div>
                    <div class="page-buttons">
                        <button @click="openNewProductModal" class="btn-add">
                            <span class="material-symbols-outlined"> box_add </span>
                            Adicionar Produtos
                        </button>
                    </div>
                </div>
                <div class="page-resupply-search not-print">
                    <div class="resupply-search-buttons">
                        <StandardInput placeholder="Nome do produto" class="resupply-filter" :type="'text'"
                            :value="productFilter" :action="(value) => (productFilter = value)" />
                        <StandardInput class="resupply-filter-select" :type="'select'" placeholder="Categorias"
                            :list="my_categories" :action="(value) => (categoryFilter = value)" />
                        <StandardInput class="resupply-filter-select" :type="'select'" placeholder="Itens" :list="[
                            { value: 'all', text: 'Todos' },
                            { value: 'directOrder', text: 'Pedido Direto' },
                            { value: 'zeroQuantity', text: 'Quantidade Zero' },
                        ]" :selected="selectedItemFilters" :action="onItemFiltersChange" />
                    </div>
                </div>

                <div class="resupply-actions-container">
                    <div class="resupply-actions not-print" v-if="selectedProductsCount > 0">
                        <button @click="extract">
                            <span class="material-symbols-outlined"> concierge </span>
                            <span>Gerar Nova Requisição</span>
                        </button>
                        <button @click="removeSelectedOneByOne">
                            <span class="material-symbols-outlined"> delete </span>
                            Remover Selecionados ({{ selectedProductsCount }})
                        </button>
                    </div>
                </div>
                <div v-if="showSuggestionAlert" class="resupply-alert not-print">
                    <div class="resupply-alert-text">
                        <span class="material-symbols-outlined"> error </span>
                        <span>
                            Seu ajuste nos campos de quantidade/estoque ativou uma sugestão automática
                            com base no histórico do produto e estoque atual. Deseja aplicar?
                        </span>
                    </div>
                    <div class="resupply-alert-actions">
                        <button class="ignore" @click="closeSuggestionAlert">Ignorar</button>
                        <button class="apply" @click="applySuggestion">Aplicar Sugestões</button>
                    </div>
                </div>

                <div class="resupply-table-container desktop">
                    <table class="resupply-table">
                        <thead>
                            <tr>
                                <th class="not-print">
                                    <input type="checkbox" :checked="selectAll" ref="selectAllCheckbox"
                                        @change="toggleSelectAll" />
                                </th>
                                <th>Nome</th>
                                <th>Embalagem</th>
                                <th>Qtd.</th>
                                <th>Estoque</th>
                                <th>Qtd.Padrão</th>
                                <th>Sugestão</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in visible_products()" :key="i">
                                <td class="not-print">
                                    <input type="checkbox" v-model="item.extract" @change="toggleProductSelection" />
                                </td>
                                <td style="display: flex; flex-direction: column">
                                    {{ item.pro_descricao }}
                                    <span style="font-size: 12px">{{ item.pro_ean }}</span>
                                </td>
                                <td>
                                    <div style="display: flex; align-items: center">
                                        {{
                                            item.pro_generico == 1
                                                ? item.pro_unidade_compra
                                        : item.pro_embalagem
                                        }}
                                        <i class="material-symbols-outlined" style="cursor: pointer; margin-left: 8px"
                                            @click="edit_wrap(item)"
                                            v-if="can('PRODUCT', 'DELETE') && item.pro_generico == 0">keyboard_arrow_down</i>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-wrapper">
                                        <input type="number" :value="item.qtd" min="0" class="input-qtd not-print"
                                            :class="{
                                                'new-product-quantity': item.isNewProduct,
                                            }" @focus="saveOriginalValues(item)" @input="handleInputChange(item, 'qtd', $event.target.value)"
                                            @blur="saveFieldAutomatically(item, 'qtd')"
                                            @keydown="handleKeydown($event, 'qtd', item, i)" ref="qtdInputs" />
                                        <i v-if="item.qtdSaved" class="fa fa-check"></i>
                                    </div>
                                    <span class="show-print">{{ formatNumber(item.qtd) }}</span>
                                </td>
                                <td>
                                    <div class="input-wrapper">
                                        <input v-model="item.estoque" type="number" min="0" class="input-num not-print"
                                            :class="{
                                                'estoque-field': item.estoqueSaved,
                                            }" @focus="saveOriginalValues(item)"
                                            @input="handleInputChange(item, 'estoque', $event.target.value)"
                                            @blur="handleBlur(item, 'estoque')"
                                            @keydown="handleKeydown($event, 'estoque', item, i)" ref="estoqueInputs" />
                                        <i v-if="item.estoqueSaved" class="fa fa-check"></i>
                                    </div>
                                    <span class="show-print">{{ formatNumber(item.estoque) }}</span>
                                </td>
                                <td>
                                    <div class="input-wrapper">
                                        <input v-model="item.qtd_padrao" class="input-num not-print" min="0"
                                            type="number" :class="{
                                                'qtd-padrao-field': item.qtdPadraoSaved,
                                            }" @focus="saveOriginalValues(item)"
                                            @input="handleInputChange(item, 'qtdPadrao', $event.target.value)"
                                            @blur="handleBlur(item, 'qtdPadrao')"
                                            @keydown="handleKeydown($event, 'qtdPadrao', item, i)"
                                            ref="qtdPadraoInputs" />
                                        <i v-if="item.qtdPadraoSaved" class="fa fa-check"></i>
                                    </div>
                                    <span class="show-print">{{ formatNumber(item.qtd_padrao) }}</span>
                                </td>
                                <td>{{ getSugestionPrice(item) }}</td>
                                <td class="actions not-print">
                                    <button title="Editar" @click="editProduct(item)">
                                        <span class="material-symbols-outlined"> edit </span>
                                    </button>
                                    <button title="Excluir" @click="remove(item)">
                                        <span class="material-symbols-outlined"> delete </span>
                                    </button>
                                    <button title="Análise de giro" @click="openHistoryModal(item)">
                                        <span class="material-symbols-outlined">query_stats</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="resupply-cards-container mobile">
                    <div class="resupply-card" v-for="(item, i) in visible_products()" :key="i">
                        <div class="card-header" style="background: none">
                            <input type="checkbox" v-model="item.extract" @change="toggleProductSelection" />
                            <div class="card-title">
                                {{ item.pro_descricao }}
                                <span>{{ item.pro_ean }}</span>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <label>Embalagem:</label>
                                <div>{{ item.pro_embalagem }}</div>
                            </div>
                            <div class="row">
                                <label>Qtd.:</label>
                                <input type="number" :value="item.qtd" min="0" class="input-qtd" :class="{
                                    'saved-feedback': item.showSaveFeedback,
                                    'new-product-quantity': item.isNewProduct,
                                }" @input="handleInputChange(item, 'qtd', $event.target.value)"
                                    @blur="saveFieldAutomatically(item, 'qtd')" />
                            </div>
                            <div class="row">
                                <label>Estoque:</label>
                                <input type="number" v-model="item.estoque" min="0" class="input-num" :class="{
                                    'estoque-field': item.estoqueSaved,
                                }" @input="handleInputChange(item, 'estoque', $event.target.value)"
                                    @blur="handleBlur(item, 'estoque')" />
                            </div>
                            <div class="row">
                                <label>Qtd. Padrão:</label>
                                <input type="number" v-model="item.qtd_padrao" min="0" class="input-num" :class="{
                                    'qtd-padrao-field': item.qtdPadraoSaved,
                                }" @input="handleInputChange(item, 'qtdPadrao', $event.target.value)"
                                    @blur="handleBlur(item, 'qtdPadrao')" />
                            </div>
                            <div class="row">
                                <label>Sugestão:</label>
                                <div>{{ getSugestionPrice(item) }}</div>
                            </div>

                            <div class="card-actions">
                                <button title="Editar" @click="editProduct(item)">
                                    <span class="material-symbols-outlined">edit</span>
                                </button>
                                <button title="Excluir" @click="remove(item)">
                                    <span class="material-symbols-outlined">delete</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide">
            <HistoryResupplyModal :productsList="visible_products()" :product="current_product"
                :currentProductIndex="currentProductIndex" :quotationId="quotationId" :proId="currentProductProId"
                :cliId="currentProductCliId" :storeNumber="store_number" :quantityInput="getCurrentProductQuantity()"
                v-if="is_history_resupply_modal_open" @close="is_history_resupply_modal_open = false"
                @product-change="handleProductChange" />
        </transition>
        <new-product-modal v-if="showEditProductModal" :product="editProductData || {}"
            :closeDialog="closeEditProductModal" :categories="[]" @emit_product="() => { }"
            @reload_products="getProducts" @close="closeEditProductModal" />
        <ResuplyProductsNewModal v-if="showResuplyNewProductModal" :closeDialog="closeResuplyNewProductModal"
            :initialData="newProductData" @productSaved="handleProductSaved" :quotation="quotationId"
            :storeNumber="store_number" :clientId="clientId" />
        <ProductWrapModal v-if="open_edit_wrap && current_product" :product="current_product" @close="
            open_edit_wrap = false;
        getProducts();
        " />
    </div>
</template>
<script>
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import QuotationService from "@/services/QuotationService";
import RequestsService from "@/services/v2/requests.service";
import RequestsServiceV3 from "@/services/v3/request.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import ProductService from "@/services/v2/products.service";
import HistoryResupplyModal from "@/components/partials/history-resupply.modal.vue";
import NewProductModal from "@/modals/new-product/new-product.modal";
import ResuplyProductsNewModal from "@/modals/resupply-products/resupply-products-new.modal.vue";
import { perm_mixin } from "@/mixins/permission.mixin";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal";
import ExcelDownload from "@/services/ExcelDownload.js";

export default {
    mixins: [perm_mixin, loaderMixin],
    components: {
        StandardInput,
        HistoryResupplyModal,
        NewProductModal,
        ResuplyProductsNewModal,
        ProductWrapModal,
    },
    props: ["quotation"],
    data() {
        return {
            quotationData: null,
            quotationNumber: "",
            selectAll: false,
            isSelectAllIndeterminate: false,
            showActions: false,
            products: [],
            selectUnit: "",
            svc: new RequestsService(),
            svc_v3: new RequestsServiceV3(),
            service: new QuotationService(),
            services: new ProductService(),
            loading: false,
            savedProducts: [],
            editing: false,
            item: {
                nomeSolicitacao: "",
            },
            my_products: [],
            my_categories: [{ value: undefined, text: "TODOS" }],
            productFilter: "",
            categoryFilter: "",
            product_name_filter: null,
            is_history_resupply_modal_open: false,
            current_product: null,
            selectedProduct: {},
            subrequestData: null,
            subrequests: [],
            all_subrequests: [],
            current_subrequest: null,
            store_number: null,
            quotation_info: null,
            has_attempted_store_load: false,
            current_store_number: null,
            showNewProductModal: false,
            is_loading_provider: false,
            isLocked: true,
            currentProductIndex: 0,
            showModal: false,
            showResuplyNewProductModal: false,
            newProductData: {},
            showEditProductModal: false,
            editProductData: {},
            showSuggestionAlert: false,
            pendingSuggestionProduct: null,
            originalProductValues: {},
            suggestionTimeout: null,
            filters: {
                directOrder: false,
                zeroQuantity: false,
            },
            selectedItemFilters: ["all"],
            cancelSource: null,
            searchTime: null,
            originalProducts: [],
            filteredProducts: [],
            whitelabel: null,
            open_edit_wrap: false,
            autoSaveTimeout: null,
            pendingAutoSaves: new Map(),
            showSaveButtons: {},
            lastFocusedField: null,
            lastFocusedProductId: null,
            newlyAddedProductIds: new Set(),
            savingStatus: "idle",
            saveTimeout: null,
            lastSaveTime: null,
        };
    },
    computed: {
        quotationId() {
            return Number(this.$route.params.id || this.quotation);
        },
        clientId() {
            return this.$store.state.user.cli_id;
        },
        currentProductProId() {
            return this.current_product?.pro_codInterno
                ? Number(this.current_product.pro_codInterno)
                : 0;
        },
        currentProductCliId() {
            return this.current_product?.cli_id || this.clientId;
        },
        currentStoreNumber() {
            return this.store_number ? Number(this.store_number) : 0;
        },
        selectedProducts() {
            const visibleProducts = this.visible_products();
            return Array.isArray(visibleProducts)
                ? visibleProducts.filter((product) => product.extract)
                : [];
        },
        selectedProductsCount() {
            return Array.isArray(this.selectedProducts) ? this.selectedProducts.length : 0;
        },
        hasActiveItemFilters() {
            return this.filters.directOrder || this.filters.zeroQuantity;
        },
        activeItemFiltersCount() {
            let count = 0;
            if (this.filters.directOrder) count++;
            if (this.filters.zeroQuantity) count++;
            return count;
        },
    },
    methods: {
        matchesFilter(description, filter) {
            if (!filter) return true;
            if (!description) return false;

            const lowerDesc = description.toLowerCase();
            const lowerFilter = filter.toLowerCase();

            if (lowerFilter.includes('%') || lowerFilter.includes('.')) {
                // Escape regex special chars except % and ., then replace both with .*
                const regexPattern = lowerFilter
                    .replace(/[+*?^${}()|[\]\\]/g, '\\$&')
                    .replace(/%|\./g, '.*');
                return new RegExp(regexPattern).test(lowerDesc);
            }

            return lowerDesc.includes(lowerFilter);
        },
        goBack() {
            this.$router.push("/cliente/monitores/ressuprimento");
        },
        formatNumber(value) {
            if (value === null || value === undefined) return "0";
            const num = parseFloat(value);
            return isNaN(num) ? "0" : num.toString();
        },
        edit_wrap(product) {
            product.embalagem = product.pro_embalagem;
            product.descricaoProduto = product.pro_descricao;
            this.current_product = product;
            this.open_edit_wrap = true;
        },
        openNewProductModal() {
            this.newProductData = {};
            this.showResuplyNewProductModal = true;
        },

        closeResuplyNewProductModal() {
            this.showResuplyNewProductModal = false;
            this.newProductData = {};

            this.getProducts();
        },
        handleProductSaved(savedProduct) {
            this.snack("Produto adicionado com sucesso!");
            if (savedProduct && savedProduct.pro_id) {
                const alreadyExists = this.products.some((p) => p.pro_id === savedProduct.pro_id);

                if (!alreadyExists) {
                    this.$set(savedProduct, "isNewProduct", true);
                }
            }
        },
        getCurrentProductQuantity() {
            if (!this.current_product) return 0;

            return parseFloat(this.current_product.qtd) || 0;
        },
        onItemFiltersChange(values) {
            if (!Array.isArray(values)) {
                values = [values];
            }

            this.selectedItemFilters = values;

            if (values.includes("all")) {
                this.filters.directOrder = false;
                this.filters.zeroQuantity = false;
                this.selectedItemFilters = ["all"];
            } else {
                this.filters.directOrder = values.includes("directOrder");
                this.filters.zeroQuantity = values.includes("zeroQuantity");
                this.selectedItemFilters = values.filter((value) => value !== "all");
            }
        },
        async loadQuotationData() {
            if (this.quotationId) {
                this.loading = true;
                try {
                    await this.getProducts();
                    await this.loadRequestName();
                } catch (error) {
                    this.handleError(error);
                } finally {
                    this.loading = false;
                }
            }
            this.quotationNumber = this.quotationId;
        },
        async loadRequestName() {
            this.loading = true;
            try {
                const response = await this.service.listResupply();
                const data = response.data;

                if (data && data.cotacoes && data.cotacoes.data) {
                    const requisicaoAtual = data.cotacoes.data.find(
                        (cotacao) => cotacao.numeroCotacao == this.quotationId
                    );

                    if (requisicaoAtual) {
                        this.item.nomeSolicitacao =
                            requisicaoAtual.nomeSolicitacao ||
                            `Requisição ${this.quotationId}`;
                        this.item.nomeLoja = requisicaoAtual.nomeLoja || "Não especificada";
                    } else {
                        this.item.nomeSolicitacao = `Requisição ${this.quotationId}`;
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar nome da requisição:", error);
                this.item.nomeSolicitacao = `Requisição ${this.quotationId}`;
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.loading = false;
            }
        },
        group_subrequests(data) {
            let result = [];
            if (!data || !Array.isArray(data)) {
                return result;
            }

            data.forEach((s) => {
                if (!s) return;

                var found = result.find((ss) => ss && ss.vendedor_id == s.vendedor_id);
                if (found) {
                    found.total = (found.total || 0) + (s.total || 0);
                    return;
                } else {
                    found = {
                        ...s,
                        total: s.total || 0,
                    };
                }
                result.push(found);
            });
            return result;
        },
        sort_subrequests() {
            let result = [];
            this.is_loading_provider = false;
            if (this.subrequests && Array.isArray(this.subrequests)) {
                result = result.concat(
                    this.subrequests.sort((a, b) => {
                        const nomeA = a?.for_nome || "";
                        const nomeB = b?.for_nome || "";
                        return nomeA.localeCompare(nomeB);
                    })
                );
                this.subrequests = result;
            }
        },
        async getProducts() {
            if (!this.quotationId) {
                return;
            }
            try {
                const response = await this.service.getProductsResupply(this.quotationId);
                const data = response.data;

                if (data.loja && data.loja.length > 0) {
                    this.store_number = data.loja[0].loj_numeroLoja;
                    this.current_store_number = data.loja[0].loj_numeroLoja;
                }
                const currentProductIds = this.products?.length
                    ? new Set(this.products.map((p) => p.pro_id))
                    : new Set();

                this.originalProducts = data.produtos.map((product) => ({
                    ...product,
                    extract: false,
                    qtd: product.quantidade || 0,
                    estoque: product.estoque || 0,
                    qtdPadrao: product.qtdPadrao || 0,
                    sugestoes: product.sugestoes || 0,
                    selectedEmbalagem: this.extractEmbalagem(product),
                    originalQtd: product.quantidade || 0,
                    originalEstoque: product.estoque || 0,
                    originalQtdPadrao: product.qtdPadrao || 0,
                    estoqueSaved: false,
                    qtdPadraoSaved: false,
                    isNewProduct:
                        this.products?.length > 0 && !currentProductIds.has(product.pro_id),
                }));

                this.products = [...this.originalProducts];
                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
                this.showActions = false;
                this.updateSelectAllState();

                this.quotationNumber = this.quotationId;
            } catch (error) {
                ErrorHandlerService.handler(error, this.$store);
                throw error;
            }
        },
        save_title() {
            const requestId = this.quotationId || this.quotation;

            if (!requestId || !this.item || !this.item.nomeSolicitacao) {
                console.error("ID da requisição ou nome não encontrado");
                this.snack("Erro: ID da requisição não encontrado", "error");
                return;
            }

            this.loading = true;
            this.svc_v3
                .update_resupply_title(requestId, this.item.nomeSolicitacao)
                .then((resp) => {
                    this.editing = false;
                    this.loading = false;
                    this.snack("Atualizado com sucesso!");
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        editName() {
            this.editing = true;
            this.$nextTick(() => {
                const input = document.getElementById("editNameInput");
                if (input) {
                    input.focus();
                    input.select();
                }
            });
        },
        downloadExcel() {
            setTimeout(() => {
                const payload = {
                    tableName: "Produtos",
                    userName: localStorage.getItem("user_name"),
                    author: this.whitelabel && this.whitelabel.data.providers.text_window,
                    headerColor: this.whitelabel && this.whitelabel.data.colors.primary,
                    store: this.filters.store
                        ? this.filters.store.loj_nomeFantasia
                        : localStorage.getItem("grupo"),
                    cot: "#" + this.quotationId,
                    header: ["Código", "Nome", "Embalagem", "Qtd.", "Estoque"],
                    body: this.products.map((value) => {
                        return [
                            value.pro_ean,
                            value.pro_descricao,
                            value.pro_generico == 1 ? value.pro_unidade_compra : value.pro_embalagem,
                            value.soma_quantidades || value.quantidade,
                            value.estoque || 0,
                        ];
                    }),
                };
                new ExcelDownload(payload);
            }, 100);
        },
        download_pdf() {
            let callback = (data) => {
                var file = new Blob([data], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                var el = document.getElementById("download-pdf");
                var title = "produtos-cotacao-" + this.quotationId + ".pdf";
                el.download = title;
                el.href = fileURL;
                el.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(fileURL);
                }, 100);
            };

            this.is_loading_pdf = true;
            this.svc
                .request_products_pdf_report(
                    this.quotationId,
                    this.filters.store ? this.filters.store.loj_id : null
                )
                .then((response) => response.data)
                .then(callback)
                .catch((error) => {
                    this.is_loading_pdf = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        print() {
            setTimeout(() => {
                const printContent = document.getElementById("modalBodyPrint").cloneNode(true);

                const notPrintElements = printContent.querySelectorAll(".not-print");
                notPrintElements.forEach((el) => el.remove());

                const printElements = printContent.querySelectorAll(".show-print");
                printElements.forEach((el) => {
                    el.style.display = "block";
                });

                const printStyles = `
          <style>
            @media print {
              body { margin: 20px; font-family: Arial, sans-serif; }
              .not-print, .not-print * { display: none !important; }
              .show-print, .show-print * { display: block !important; }
              .print-header { display: flex !important; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 15px; }
              .resupply-table { width: 100%; border-collapse: collapse; font-size: 12px; }
              .resupply-table th, .resupply-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              .resupply-table th { background-color: #f5f5f5; font-weight: bold; }
              .resupply-table-container { margin-top: 20px; }
              @page { margin: 15mm; }
              h2 { color: #333; margin-bottom: 10px; }
            }
          </style>
        `;

                const conteudoImpressao = `
          <html>
            <head>
              <title>Produtos da Requisição - ${this.quotationNumber}</title>
              ${printStyles}
            </head>
            <body>
              ${printContent.innerHTML}
            </body>
          </html>
        `;

                const telaImpressao = window.open("", "_blank", "width=800,height=600");
                telaImpressao.document.write(conteudoImpressao);
                telaImpressao.document.close();

                setTimeout(() => {
                    telaImpressao.focus();
                    telaImpressao.print();
                    telaImpressao.close();
                }, 500);
            }, 500);
        },
        exportProducts() {
            let text = "";
            this.visible_products().forEach(
                (t) => (text += `${t.pro_ean},${t.quantidade},${t.estoque || 0}\n`)
            );
            var blob = new Blob([text], {
                type: "text/plain;charset=utf-8",
            });
            saveAs(blob, "products.txt");
        },
        visible_products() {
            if (!this.originalProducts || !Array.isArray(this.originalProducts)) {
                return [];
            }

            let resp = this.originalProducts.filter((p) => !p.deleted);

            if (this.productFilter) {
                resp = resp.filter((p) =>
                    this.matchesFilter(p.pro_descricao, this.productFilter)
                );
            }

            if (this.categoryFilter && this.categoryFilter.cat_id) {
                resp = resp.filter((p) => p.cat_id == this.categoryFilter.cat_id);
            }

            const itemFilters = Array.isArray(this.selectedItemFilters)
                ? this.selectedItemFilters
                : [this.selectedItemFilters];

            if (!itemFilters.includes("all")) {
                if (this.filters.directOrder) {
                    resp = resp.filter(
                        (p) =>
                            p.pro_pedido_direto === true ||
                            p.pro_pedido_direto === 1 ||
                            p.pro_pedido_direto === "1"
                    );
                }

                if (this.filters.zeroQuantity) {
                    resp = resp.filter((p) => {
                        const quantidade = parseFloat(p.qtd || p.quantidade || 0);
                        return quantidade === 0;
                    });
                }
            }

            this.filteredProducts = resp;
            return resp;
        },
        searchProduct() {
            const time = new Date();
            this.searchTime = time;
            setTimeout(() => {
                if (this.searchTime == time) {
                    this.page = 1;
                    this.load_my_products();
                }
            }, 500);
        },
        cancelSearch() {
            if (this.cancelSource) {
                this.cancelSource.cancel("Start new search, stop active search");
            }
        },
        openHistoryModal(product) {
            const hasIdentifier = product.pro_ean || product.pro_codInterno;

            if (!hasIdentifier) {
                this.$swal.fire({
                    icon: "warning",
                    title: "Histórico não disponível",
                    text: "Este produto não possui histórico de compras e vendas disponível.",
                });
                return;
            }

            const visibleProducts = this.visible_products();
            this.currentProductIndex = visibleProducts.findIndex(
                (p) => p.pro_id === product.pro_id
            );
            this.current_product = product;
            this.store_number = this.store_number || this.current_store_number;

            this.is_history_resupply_modal_open = true;
        },
        handleProductChange(newIndex) {
            const visibleProducts = this.visible_products();
            if (visibleProducts[newIndex]) {
                this.currentProductIndex = newIndex;
                this.current_product = visibleProducts[newIndex];
            }
        },
        closeHistoryModal() {
            this.is_history_resupply_modal_open = false;
        },
        toggleLock() {
            this.isLocked = !this.isLocked;
        },
        async removeSelectedOneByOne() {
            if (this.selectedProductsCount === 0) return;

            try {
                for (const product of this.selectedProducts) {
                    await this.service.remove_product_ressuply(this.quotationId, product.pro_id);
                    product.deleted = true;
                }

                this.snack(
                    `${this.selectedProductsCount} produto(s) removido(s) com sucesso!`,
                    "success"
                );
                await this.getProducts();
                this.$emit("loadRessuply");
            } catch (error) {
                console.error("Erro ao remover produtos:", error);
                this.handleRemoveError(error);
            }
        },

        async remove(product) {
            try {
                await this.service.remove_product_ressuply(this.quotationId, product.pro_id);
                product.deleted = true;
                await this.getProducts();
                this.$emit("loadRessuply");
                this.snack("Produto removido com sucesso!", "success");
            } catch (error) {
                console.error("Erro ao remover produto:", error);
                this.handleRemoveError(error, product.pro_descricao);
            }
        },

        editProduct(product) {
            this.editProductData = {
                ...product,
                pro_id: product.pro_id,
                pro_descricao: product.pro_descricao,
                pro_ean: product.pro_ean,
                pro_embalagem: product.pro_embalagem,
                pro_unidade_compra: product.pro_unidade_compra,
                pro_generico: product.pro_generico,
                pro_pedido_direto: product.pro_pedido_direto,
                pro_status: product.pro_status,
                cat_id: product.cat_id,
            };
            this.showEditProductModal = true;
        },

        closeEditProductModal() {
            this.showEditProductModal = false;
            this.editProductData = {};
        },

        handleError(error) {
            if (ErrorHandlerService && typeof ErrorHandlerService.handler === "function") {
                ErrorHandlerService.handler(error, this.$store);
            } else if (
                ErrorHandlerService &&
                typeof ErrorHandlerService.handle === "function"
            ) {
                ErrorHandlerService.handle(error, this.$store);
            } else {
                console.error("Erro:", error);
                this.$swal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Ocorreu um erro inesperado.",
                });
            }
        },

        handle_navigation($event, prod) {
            this.navigate($event, {
                ref: "amount",
                callback: {
                    function: this.update_one,
                    params: prod,
                },
            });
        },

        handle_my_products_navigation($event, product) {
            this.navigate($event, {
                ref: "new-amount",
                callback: {
                    function: this.add_product,
                    params: product,
                },
            });
        },
        hasSignificantChange(oldValue, newValue) {
            const oldVal = parseFloat(oldValue) || 0;
            const newVal = parseFloat(newValue) || 0;

            if (oldVal === 0 && newVal > 0) return true;

            if (Math.abs(newVal - oldVal) >= 5) return true;
            if (oldVal > 0 && Math.abs((newVal - oldVal) / oldVal) >= 0.2) return true;

            return false;
        },
        applySuggestion() {
            const visibleProducts = this.visible_products();
            let productsWithSuggestion = 0;

            visibleProducts.forEach((product) => {
                const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const estoque = parseFloat(product.estoque) || 0;

                if (qtdPadrao > estoque) {
                    const sugestao = this.calculateSuggestion(product);

                    if (sugestao > 0) {
                        product.qtd = sugestao;
                        product.quantidade = sugestao;
                        product.changed = true;
                        productsWithSuggestion++;

                        if (!this.originalProductValues[product.pro_id]) {
                            this.originalProductValues[product.pro_id] = {};
                        }
                        this.originalProductValues[product.pro_id].qtd = sugestao;
                        product.originalQtd = sugestao;
                    }
                }
            });

            this.closeSuggestionAlert();

            if (productsWithSuggestion > 0) {
                this.service.updateQuotationProductsAmount(
                    this.quotationId,
                    visibleProducts
                        .filter((p) => p.changed)
                        .map((p) => ({
                            pro_id: p.pro_id,
                            quantidade: p.qtd
                        }))
                ).then(() => {
                    this.$swal.fire({
                        icon: "success",
                        title: "Sugestões Aplicadas!",
                        text: `Sugestões de quantidade foram aplicadas para ${productsWithSuggestion} produtos.`,
                        timer: 2000,
                        showConfirmButton: false,
                    });
                })
            } else {
                this.$swal.fire({
                    icon: "info",
                    title: "Nenhuma Sugestão",
                    text:
                        "Não há produtos com quantidade padrão maior que estoque para aplicar sugestões.",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        },

        getSugestionPrice(item) {
            return this.calculateSuggestion(item);
        },

        calculateSuggestion(item) {
            if (!item) return 0;

            const qtdPadrao = parseFloat(item.qtd_padrao) || 0;
            const estoque = parseFloat(item.estoque) || 0;

            if (qtdPadrao <= estoque) return 0;

            const diferenca = qtdPadrao - estoque;

            if (diferenca <= 0) return 0;

            if (item.pro_generico == 1) {
                return diferenca;
            }

            if (item.pro_embalagem && item.pro_embalagem.includes(" ")) {
                const partes = item.pro_embalagem.split(" ");
                if (partes.length >= 2) {
                    const fatorEmbalagem = parseFloat(partes[1]) || 1;
                    return Math.round(diferenca / fatorEmbalagem);
                }
            }

            return Math.round(diferenca);
        },

        shouldShowSuggestionForProduct(product) {
            if (!product) return false;

            const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
            const estoque = parseFloat(product.estoque) || 0;

            return qtdPadrao > estoque;
        },

        closeSuggestionAlert() {
            this.showSuggestionAlert = false;
            this.pendingSuggestionProduct = null;
            if (this.suggestionTimeout) {
                clearTimeout(this.suggestionTimeout);
                this.suggestionTimeout = null;
            }
        },

        async saveFieldAutomatically(product, field) {
            if (field !== "qtd") {
                return;
            }

            if (this.loading || !product || !product.pro_id) return;

            const currentValue = parseFloat(product[field]) || 0;
            const originalValue =
                parseFloat(
                    product[`original${field.charAt(0).toUpperCase() + field.slice(1)}`]
                ) || 0;

            if (currentValue === originalValue) {
                return;
            }

            if (this.saveTimeout) {
                clearTimeout(this.saveTimeout);
            }

            this.savingStatus = "saving";

            const productKey = product.pro_id;

            if (this.pendingAutoSaves.has(productKey)) {
                clearTimeout(this.pendingAutoSaves.get(productKey));
            }

            const timeoutId = setTimeout(async () => {
                try {
                    const quotationService = new QuotationService();

                    const updateData = {
                        pro_id: product.pro_id,
                        quantidade: field === "qtd" ? currentValue : product.qtd,
                        estoque: product.estoque?.toString() || "0",
                        qtd_padrao: product.qtd_padrao?.toString() || null,
                        obs: null,
                        custo: null,
                        venda: null,
                    };

                    await quotationService.updateQuotationProductAmount(
                        this.quotationId,
                        updateData
                    );

                    product[
                        `original${field.charAt(0).toUpperCase() + field.slice(1)}`
                    ] = currentValue;

                    this.pendingAutoSaves.delete(productKey);

                    this.showSaveFeedback(product, field);
                    this.savingStatus = "saved";

                    this.lastSaveTime = new Date();
                    this.saveTimeout = setTimeout(() => {
                        this.savingStatus = "idle";
                    }, 3000);
                } catch (error) {
                    console.error(`Erro ao salvar ${field} automaticamente:`, error);

                    product[field] = originalValue;

                    this.$swal.fire({
                        icon: "error",
                        title: "Erro ao salvar",
                        text: `Não foi possível salvar a alteração no ${field}.`,
                        timer: 2000,
                        showConfirmButton: false,
                    });

                    this.pendingAutoSaves.delete(productKey);
                    this.savingStatus = "idle";
                }
            }, 800);

            this.pendingAutoSaves.set(productKey, timeoutId);
        },

        showSaveFeedback(item, field) {
            if (field === "qtd") item.qtdSaved = true;
            if (field === "estoque") item.estoqueSaved = true;
            if (field === "qtdPadrao") item.qtdPadraoSaved = true;
        },

        handleBlur(item, field) {
            const currentValue =
                parseFloat(item[field === "qtdPadrao" ? "qtd_padrao" : field]) || 0;
            const originalValue = this.originalProductValues[item.pro_id]?.[field] || 0;

            if (currentValue !== originalValue) {
                this.savingStatus = "saving";
                this.saveIndividualProduct(item, field);
            }
        },
        handleInputChange(item, field, value) {
            const numericValue = Math.max(0, parseFloat(value) || 0);

            if (field === "qtdPadrao") {
                item.qtd_padrao = numericValue;
            } else {
                item[field] = numericValue;
            }

            if (field === "qtd" && numericValue > 0) {
                this.$set(item, "hasNewQuantity", true);
            }

            if (!this.originalProductValues[item.pro_id]) {
                this.saveOriginalValues(item);
            }

            if (this.shouldShowSuggestionForProduct(item)) {
                this.checkForSuggestion(item, field, numericValue);
            }
        },
        saveOriginalValues(product) {
            if (!product.pro_id) return;

            this.originalProductValues[product.pro_id] = {
                qtd: parseFloat(product.qtd) || 0,
                estoque: parseFloat(product.estoque) || 0,
                qtd_padrao: parseFloat(product.qtd_padrao) || 0,
            };

            product.originalQtd = parseFloat(product.qtd) || 0;
            product.originalEstoque = parseFloat(product.estoque) || 0;
            product.originalQtdPadrao = parseFloat(product.qtd_padrao) || 0;
        },
        checkForSuggestion(product, field, newValue) {
            if (this.suggestionTimeout) {
                clearTimeout(this.suggestionTimeout);
            }
            this.suggestionTimeout = setTimeout(() => {
                const originalValues = this.originalProductValues[product.pro_id];

                if (!originalValues) {
                    return;
                }

                const originalValue = originalValues[field];
                const hasChanged = this.hasSignificantChange(originalValue, newValue);

                const qtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const estoque = parseFloat(product.estoque) || 0;
                const shouldShowSuggestion = qtdPadrao > estoque;

                if (hasChanged && !this.showSuggestionAlert && shouldShowSuggestion) {
                    this.pendingSuggestionProduct = {
                        ...product,
                        changedField: field,
                        originalValue: originalValue,
                        newValue: newValue,
                    };
                    this.showSuggestionAlert = true;
                }
            }, 800);
        },
        load_my_products() {
            this.loading = true;

            this.cancelSearch(() => {
                this.loading = true;
            });
            const params = {
                nomeproduto: this.product_name_filter,
                page: this.page,
                deleted: 0,
            };
            return this.service
                .getProdutosClientePorPagina(params, this.cancelSource?.token)
                .then((data) => {
                    this.my_products = data.data.produtos.data;
                    data.data.categorias.forEach((element) => {
                        if (element.cat_excluido != "1" && element.cat_status != "0")
                            this.my_categories.push({ value: element, text: element.cat_descricao });
                    });

                    this.page = data.data.produtos.current_page;
                    setTimeout(() => {
                        this.total_items = data.data.produtos.total;
                    }, 200);
                    //this.totalPaginas = data.data.produtos.last_page;
                    this.products.forEach((v) => (v.expanded = false));
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        toggleSelectAll() {
            const visibleProducts = this.visible_products();
            const shouldSelectAll = !this.selectAll;

            visibleProducts.forEach((product) => {
                product.extract = shouldSelectAll;
            });

            this.selectAll = shouldSelectAll;
            this.isSelectAllIndeterminate = false;
        },
        initializeOriginalValues() {
            this.originalProductValues = {};
            this.visible_products().forEach((product) => {
                this.saveOriginalValues(product);
            });
        },
        toggleProductSelection() {
            const visibleProducts = this.visible_products();
            const selectedCount = visibleProducts.filter((p) => p.extract).length;
            const total = visibleProducts.length;

            if (selectedCount === 0) {
                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
            } else if (selectedCount === total) {
                this.selectAll = true;
                this.isSelectAllIndeterminate = false;
            } else {
                this.selectAll = false;
                this.isSelectAllIndeterminate = true;
            }
        },
        updateSelectAllState() {
            const visibleProducts = this.visible_products();

            if (visibleProducts.length === 0) {
                this.selectAll = false;
                this.isSelectAllIndeterminate = false;
                return;
            }

            const selectedCount = visibleProducts.filter((product) => product.extract).length;
            const totalVisible = visibleProducts.length;

            this.selectAll = selectedCount === totalVisible;
            this.isSelectAllIndeterminate = selectedCount > 0 && selectedCount < totalVisible;
        },

        forceCheckboxUpdate() {
            this.$nextTick(() => {
                const checkbox = this.$refs.selectAllCheckbox;
                if (checkbox) {
                    checkbox.indeterminate = this.isSelectAllIndeterminate;
                }
            });
        },
        any_to_extract() {
            return this.visible_products().some((i) => i.extract);
        },
        extract() {
            if (this.selectedProductsCount === 0) return;

            if (!this.any_to_extract()) {
                this.present_error("Selecione ao menos 1 item para proseguir!");
                return;
            }
            let items = this.visible_products()
                .filter((p) => p.extract)
                .map((i) => {
                    return { ...i, id: i.idProduto, quantity: i.quantidade };
                });
            this.confirm_action({
                message: "Também excluir produtos selecionados da requisição atual?",
                cancel_text: "Não",
                confirm_tex: "Sim",
                deny_text: "Enviar sem exclusão",
                deny_callback: (result) => {
                    this.present_loader("Enviando requisição...");
                    this.svc_v3
                        .extract_resupply(this.quotationId, { items })
                        .then(this.getProducts)
                        .then((resp) => {
                            this.$emit("loadRessuply");
                            this.dismiss_loader();
                        });
                },
                callback: (result) => {
                    this.present_loader("Enviando requisição...");
                    this.svc_v3
                        .extract_resupply(this.quotationId, { items, remove_origin: true })
                        .then(this.getProducts)
                        .then((resp) => {
                            this.$emit("loadRessuply");
                            this.dismiss_loader();
                        });
                },
            });
        },
        closeDropdownOnClickOutside(e) {
            const dropdown = this.$el.querySelector(".items-filter");
            if (dropdown && !dropdown.contains(e.target)) {
                this.showItemsDropdown = false;
            }
        },
        extractEmbalagem(product) {
            if (!product) return "UN";

            if (product.pro_generico == 1) {
                return product.pro_unidade_compra || "UN";
            }

            if (product.pro_embalagem && product.pro_embalagem.includes(" ")) {
                return product.pro_embalagem.split(" ")[0];
            }

            return product.pro_embalagem || "UN";
        },
        getEmbalagensOptions(item) {
            if (!item) return this.defaultEmbalagens;

            if (item.pro_generico == 1) {
                return [{ value: item.pro_unidade_compra, text: item.pro_unidade_compra }];
            } else {
                const embalagemPadrao = item.pro_embalagem
                    ? item.pro_embalagem.includes(" ")
                        ? item.pro_embalagem.split(" ")[0]
                        : item.pro_embalagem
                    : "UN";

                const opcoes = [...this.defaultEmbalagens];

                if (embalagemPadrao && !opcoes.find((e) => e.value === embalagemPadrao)) {
                    opcoes.unshift({ value: embalagemPadrao, text: embalagemPadrao });
                }

                return opcoes;
            }
        },
        async onEmbalagemChange(item) {
            if (!item || !item.pro_id) return;

            const loading = this.$loading?.show();

            try {
                const payload = {
                    wrap: item.selectedEmbalagem,
                };

                const services = new ProductService();
                await services.update_wrap(item.pro_id, payload);

                item.pro_embalagem = payload.wrap;

                this.snack("Embalagem atualizada com sucesso!", "success");
            } catch (error) {
                console.error("Erro ao atualizar embalagem:", error);
                ErrorHandlerService.handle(error, this.$store);
                this.loadProductEmbalagem(item);
            } finally {
                loading?.hide();
            }
        },

        loadProductEmbalagem(item) {
            if (!item) return;

            if (item.pro_embalagem) {
                if (item.pro_embalagem.includes(" ")) {
                    item.selectedEmbalagem = item.pro_embalagem.split(" ")[0];
                } else {
                    item.selectedEmbalagem = item.pro_embalagem;
                }
            } else {
                item.selectedEmbalagem = "UN";
            }
        },
        hasEstoqueChanges(product) {
            if (!product || !product.pro_id) return false;

            const currentEstoque = parseFloat(product.estoque) || 0;
            const originalEstoque = parseFloat(product.originalEstoque) || 0;

            const estoqueChanged = currentEstoque !== originalEstoque;

            return estoqueChanged;
        },
        async saveIndividualProduct(product) {
            try {
                this.savingStatus = "saving";

                const quotationService = new QuotationService();

                const updateData = {
                    pro_id: product.pro_id,
                    quantidade: product.qtd,
                    estoque: product.estoque?.toString() || "0",
                    qtd_padrao: product.qtd_padrao?.toString() || "0",
                    obs: null,
                    custo: null,
                    venda: null,
                };

                await quotationService.updateQuotationProductAmount(this.quotationId, updateData);

                const currentEstoque = parseFloat(product.estoque) || 0;
                const originalEstoque = parseFloat(product.originalEstoque) || 0;
                const currentQtdPadrao = parseFloat(product.qtd_padrao) || 0;
                const originalQtdPadrao = parseFloat(product.originalQtdPadrao) || 0;

                product.originalQtd = parseFloat(product.qtd) || 0;
                product.originalEstoque = parseFloat(product.estoque) || 0;
                product.originalQtdPadrao = parseFloat(product.qtd_padrao) || 0;

                if (currentEstoque !== originalEstoque) {
                    product.estoqueSaved = true;
                }

                if (currentQtdPadrao !== originalQtdPadrao) {
                    product.qtdPadraoSaved = true;
                }

                this.snack("Produto salvo com sucesso.");

                this.savingStatus = "saved";
                this.lastSaveTime = new Date();

                if (this.saveTimeout) {
                    clearTimeout(this.saveTimeout);
                }
                this.saveTimeout = setTimeout(() => {
                    this.savingStatus = "idle";
                }, 3000);
            } catch (error) {
                console.error("Erro ao salvar produto individual:", error);
                this.snack("Erro ao salvar produto individual.", "error");
                this.savingStatus = "idle";
            }
        },
        handleKeydown(event, field, item, index) {
            if (event.key === "Enter") {
                event.preventDefault();
                const direction = event.key === "Enter" ? 1 : -1;
                this.navigateVertical(field, index, direction);
                return;
            }

            if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                event.preventDefault();
                const direction = event.key === "ArrowRight" ? 1 : -1;
                this.navigateHorizontal(field, index, direction);
                return;
            }

            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                const direction = event.key === "ArrowDown" ? 1 : -1;
                this.navigateVertical(field, index, direction);
                return;
            }
        },

        navigateHorizontal(currentField, currentIndex, direction) {
            const visibleProducts = this.visible_products();
            const fields = ["qtd", "estoque", "qtdPadrao"];
            const currentFieldIndex = fields.indexOf(currentField);

            let nextFieldIndex = currentFieldIndex + direction;

            if (nextFieldIndex < 0) {
                nextFieldIndex = fields.length - 1;
            } else if (nextFieldIndex >= fields.length) {
                nextFieldIndex = 0;
            }

            this.focusOnInput(fields[nextFieldIndex], currentIndex);
        },

        navigateVertical(currentField, currentIndex, direction) {
            const visibleProducts = this.visible_products();
            const fields = ["qtd", "estoque", "qtdPadrao"];
            const currentFieldIndex = fields.indexOf(currentField);

            let nextRowIndex = currentIndex + direction;

            if (nextRowIndex < 0) {
                nextRowIndex = 0;
            } else if (nextRowIndex >= visibleProducts.length) {
                nextRowIndex = visibleProducts.length - 1;
            }

            if (nextRowIndex !== currentIndex && this.is_history_resupply_modal_open) {
                this.currentProductIndex = nextRowIndex;
                this.current_product = visibleProducts[nextRowIndex];
                this.handleProductChange(nextRowIndex);
            }

            this.focusOnInput(currentField, nextRowIndex);
        },

        focusOnInput(field, rowIndex) {
            const refMap = {
                qtd: "qtdInputs",
                estoque: "estoqueInputs",
                qtdPadrao: "qtdPadraoInputs",
            };

            const refName = refMap[field];

            this.$nextTick(() => {
                const inputs = this.$refs[refName];
                if (inputs && inputs[rowIndex]) {
                    inputs[rowIndex].focus();
                    inputs[rowIndex].select();
                }
            });
        },
        focusAndOpenModal(product, index) {
            this.current_product = product;
            this.currentProductIndex = index;

            this.$nextTick(() => {
                const qtdInputs = this.$refs.qtdInputs;
                if (qtdInputs && qtdInputs[index]) {
                    qtdInputs[index].focus();
                    qtdInputs[index].select();
                }
            });
            this.openHistoryModal(product);
        },
    },
    watch: {
        quotationId: {
            handler: "loadQuotationData",
            immediate: true,
        },
        products: {
            handler() {
                this.$nextTick(() => this.forceCheckboxUpdate());
            },
            deep: true,
        },

        productFilter: {
            handler: function (newFilter, oldFilter) {
                if (oldFilter && !newFilter) {
                    this.products = [...this.originalProducts];
                }
                this.$nextTick(() => {
                    this.updateSelectAllState();
                    this.forceCheckboxUpdate();
                });
            },
        },

        categoryFilter: {
            handler: function () {
                this.$nextTick(() => {
                    this.updateSelectAllState();
                    this.forceCheckboxUpdate();
                });
            },
        },
        filters: {
            handler(newFilters) {
                const activeFilters = [];
                if (newFilters.directOrder) activeFilters.push("directOrder");
                if (newFilters.zeroQuantity) activeFilters.push("zeroQuantity");

                if (activeFilters.length === 0 && !this.selectedItemFilters.includes("all")) {
                    this.selectedItemFilters = ["all"];
                } else if (activeFilters.length > 0) {
                    this.selectedItemFilters = activeFilters;
                }
            },
            deep: true,
        },
        selectAll(newVal) {
            this.$nextTick(() => {
                this.forceCheckboxUpdate();
            });
        },

        isSelectAllIndeterminate(value) {
            this.$nextTick(() => {
                if (this.$refs.selectAllCheckbox) {
                    this.$refs.selectAllCheckbox.indeterminate = value;
                }
            });
        },
        selectedItemFilters: {
            handler(newFilters) {
                if (!Array.isArray(newFilters)) {
                    this.selectedItemFilters = [newFilters];
                }
            },
            deep: true,
            immediate: true,
        },
    },
    async mounted() {
        await this.load_my_products();
        document.addEventListener("click", this.closeDropdownOnClickOutside);

        this.$nextTick(() => {
            this.updateSelectAllState();
            this.forceCheckboxUpdate();

            this.initializeOriginalValues();
            this.visible_products().forEach((product) => {
                if (product.qtd_padrao && this.getSugestionPrice(product) != product.quantidade) {
                    this.pendingSuggestionProduct = {
                        ...product,
                    };
                    this.showSuggestionAlert = true;
                }
            });
        });
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeDropdownOnClickOutside);
        if (this.suggestionTimeout) {
            clearTimeout(this.suggestionTimeout);
        }

        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }

        this.pendingAutoSaves.forEach((timeoutId) => {
            clearTimeout(timeoutId);
        });
        this.pendingAutoSaves.clear();
    },
};
</script>
<style lang="scss" scoped>
@import "@/sass/commons/_variables";

#app {
    background: #eeeeee !important;
}

.page {
    display: flex;
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    padding-right: 40px;
    font-family: $font-dm !important;
    box-shadow: none !important;
    overflow: hidden;

    &.with-drawer {
        padding-right: 0;
    }
}

.page-content {
    overflow-y: scroll;
    flex: 1;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}

.page-wrapper.with-drawer .page-content {
    width: calc(100% - 420px);
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter-from {
    opacity: 0;
    transform: scale(0.9);
}

.slide-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.slide-enter-to,
.slide-leave-from {
    opacity: 1;
    transform: scale(1);
}

.slide-enter-active .modal-wrapper,
.slide-leave-active .modal-wrapper {
    transition: transform 0.3s ease;
}

.page-route-select {
    display: flex;
    align-items: center;
}

.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}

.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}

.page-title {
    font-weight: 700;
    font-size: 2.72em;
    letter-spacing: 0.15px;
    color: #605f5f;
    display: flex;
    align-items: center;
    gap: 10px;

    .quotation {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 74px;
        height: 26px;
        border-radius: 16px;
        border: 1px solid #c7c9d9;
        background-color: #eeeeee;
        padding: 4px 8px;

        font-weight: 300;
        font-size: 16px;
        color: #424242;
    }

    .save-status-indicator {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 20px;
        color: #424242;
        transition: all 0.3s ease;
    }

    .save-status-indicator .material-symbols-outlined {
        font-size: 22px;
        color: #424242;
    }

    .saving-spin {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .save-status-text {
        font-weight: 500;
        font-size: 14px;
    }
}

.desktop {
    display: block;
}

.mobile {
    display: none;
}

.page-header,
.page-name-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header-action {
    margin-top: 40px;
    display: flex;
    gap: 12px;
    color: #424242;
    cursor: pointer;
}

.info-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px 4px 6px;
    border-radius: 20px;
    background: #f0f1f7;
    border: 1px solid #c7c9d9;
    cursor: pointer;

    .info-tag-label {
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #fff;
        background: #3a3a3c;
        border-radius: 12px;
        padding: 2px 8px;
        white-space: nowrap;
    }

    .info-tag-icon {
        font-size: 16px;
        color: #605f5f;
    }

    .info-tag-value {
        font-weight: 500;
        font-size: 14px;
        color: #3a3a3c;
        white-space: nowrap;
    }

    &.edit-name {
        &:hover {
            background: #e8e9f2;
        }
    }
}

.edit-request-name {
    display: flex;
    align-items: center;
}

.edit-request-name-input {
    border-radius: 4px;
    border: 1px solid #c7c9d9;
    font-weight: 400;
    font-size: 12px;
    color: #605f5f;
    width: 200px;
    height: 40px;
    padding: 2px;
    cursor: pointer;
}

.edit-request-name-icon {
    font-size: 1.3em;
    margin-left: 1.5vw;
    cursor: pointer;
}

.page-buttons {
    display: flex;
    gap: 20px;

    .btn-add {
        width: 200px;
        height: 47px;
        display: flex;
        border-radius: 8px;
        border: 1px solid #c7c9d9;
        padding: 12px;
        gap: 16px;

        font-weight: 600;
        font-size: 14px;
        color: #424242;
    }

    .btn-save {
        width: 150px;
        display: flex;
        height: 47px;
        border-radius: 8px;
        padding: 12px;
        gap: 16px;
        border: none;
        background: #FF5722;

        font-weight: 600;
        font-size: 14px;
    }
}

.resupply-alert {
    background: #e8eaf6;
    border: 1px solid #3f51b5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-radius: 8px;

    .resupply-alert-text {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 500;
        font-size: 14px;
        color: #3f51b5;
    }

    .resupply-alert-actions {
        display: flex;
        gap: 10px;

        button {
            width: 150px;
            height: 47px;
            border-radius: 8px;
            padding: 12px;
            cursor: pointer;

            font-weight: 600;
            font-size: 14px;
            color: #424242;
        }

        .ignore {
            background: none;
            border: none;
        }

        .apply {
            background: #eeeeee;
            border: 1px solid #c7c9d9;
        }
    }
}

.resupply-actions-container {
    min-height: 20px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    position: relative;
}

.resupply-actions {
    display: flex;
    gap: 10px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: transparent;

    button {
        border: none;
        background: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-size: 14px;
        color: #424242;
    }
}

.resupply-actions button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.resupply-actions button:disabled:hover {
    transform: none;
}

.page-resupply-search {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 10px;
    font-size: 14px !important;
    font-weight: 400;
    position: relative;

    .resupply-search-buttons {
        display: flex;
        gap: 10px;

        .resupply-filter {
            width: 60%;
        }

        .resupply-filter-select {
            width: 200px;
            position: relative;
            font-size: 12px !important;
        }

        .items-filter {
            position: relative;
            width: 220px;
            margin-top: 12px;
        }

        .filter-select-display {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 42px;
            padding: 0 12px;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            transition: border-color 0.2s ease;
        }

        .filter-select-display:hover {
            border-color: #999;
        }

        .filter-select-display .icon {
            font-size: 20px;
            color: #555;
        }

        .filter-selected-label {
            font-weight: 500;
            color: #333;
            margin-left: 4px;
        }

        .items-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 8px 12px;
            display: flex;
            flex-direction: column;
            gap: 6px;
            z-index: 15;
            min-width: 100%;
            z-index: 1000;
            margin-top: 4px;
        }

        .items-dropdown label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            cursor: pointer;
            color: #333;
        }

        .items-dropdown input[type="checkbox"] {
            accent-color: #ff6600;
            width: 16px;
            height: 16px;
        }
    }
}

.resupply-table-container {
    width: 100%;
    position: relative;
    background: #fff;
    margin-top: 30px;

    &::-webkit-scrollbar {
        width: 3px;
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f8f6f6;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #f8f6f6;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #f8f6f6;
    }

    .resupply-table thead {
        position: sticky;
        top: 0;
        z-index: 3;
        height: 60px;
        background: #fff;
    }

    .resupply-table tbody {
        z-index: -3;
    }

    .resupply-table {
        position: relative;
        z-index: 1;
        width: 100%;
        font-size: 14px;
        color: #424242;
    }

    .resupply-table th {
        text-align: left;
        font-weight: 500;
        font-size: 14px;
        color: #424242;
    }

    .resupply-table td {
        padding: 10px 3px;
        vertical-align: middle;
    }

    .resupply-table input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        width: 22px;
        height: 22px;
        border: 2px solid #a5a5a5;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        background: white;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .resupply-table input[type="checkbox"]:checked {
        background-color: #FF5722;
        border-color: #FF5722;
    }

    .resupply-table input[type="checkbox"]:checked::after {
        content: "✔";
        position: absolute;
        color: white;
        font-size: 16px;
        font-weight: bold;
    }

    .resupply-table input[type="checkbox"]:hover {
        border-color: #FF5722;
    }

    .input-num,
    .input-qtd {
        max-width: 52px;
        text-align: center;
        border-radius: 8px;
        padding: 8px 4px;
        font-weight: 400;
        font-size: 14px;
        background: none;
        border: 1px solid #c7c9d9;

        &:focus {
            border-color: orange !important;
            outline: none;
        }
    }

    .button-field {
        opacity: 0.5;
    }

    .input-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;

        i {
            color: green;
            position: absolute;
            right: -20px;
            font-size: 0.9rem;
            margin: 0;
        }
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
        }

        10% {
            opacity: 1;
        }

        90% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .actions {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
    }

    .locked button,
    .actions button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 18px;
        padding: 2px;
        color: #424242;
        transition: 0.2s;
    }

    .resupply-table th:last-child,
    .resupply-table td:last-child {
        width: 180px;
        text-align: left;
    }
}

.select-unit {
    border: none;
    font-size: 14px;
    cursor: pointer;
}

.select-unidade:focus {
    outline: none;
}

.show-print {
    display: none;
}

@media only screen and (max-width: 768px) {
    .page {
        padding: 0 10px 5vh 10px;
        margin-bottom: 5vh;
        font-size: 14px;
    }

    .page-content {
        width: 100%;
        overflow-y: scroll;
    }

    .page-route-select {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .page-route-select-text {
        font-size: 1.1em;
        margin-right: 10px;
    }

    .page-route-select-icon {
        margin-right: 10px;
        font-size: 16px;
    }

    .page-title {
        font-size: 1.8em;
        margin-top: 20px;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .page-title span {
        width: auto;
        padding: 4px 8px;
        font-size: 12px;
    }

    .page-header-action span {
        font-size: 20px;
    }

    .info-tag {
        .info-tag-value {
            font-size: 13px;
        }
    }

    .page-name-actions {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-top: 20px;
    }

    .resupply-search-buttons {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    .page-resupply-search {
        flex-direction: column;
        gap: 10px;
        margin-top: 15px;
    }

    .resupply-filter {
        width: 100% !important;
    }

    .resupply-filter-select,
    .items-filter {
        width: 48% !important;
    }

    .desktop {
        display: none;
    }

    .mobile {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .resupply-cards-container {
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
        margin-top: 40px;
    }

    .resupply-card {
        border-radius: 12px;
        padding: 14px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        font-size: 14px;
    }

    .card-header {
        display: flex;
        align-items: flex-start;
        padding: 20px 0;
        gap: 8px;
        background-color: none;
    }

    .card-header input[type="checkbox"] {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 2px solid #a5a5a5;
        appearance: none;
        cursor: pointer;
    }

    .card-header input[type="checkbox"]:checked {
        background-color: #FF5722;
        border-color: #FF5722;
        position: relative;
    }

    .card-header input[type="checkbox"]:checked::after {
        content: "✔";
        position: absolute;
        color: #fff;
        font-size: 14px;
        left: 3px;
        top: 0;
    }

    .card-title {
        display: flex;
        flex-direction: column;
        font-weight: 600;
    }

    .card-title span {
        font-size: 12px;
        color: #777;
    }

    .card-body .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;
    }

    .card-body .row:last-child {
        border-bottom: none;
    }

    .card-body label {
        font-weight: 600;
        color: #3a3a3a;
    }

    .card-body input[type="number"] {
        width: 80px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #c7c9d9;
        background: #fafafa;
        padding: 5px;
        font-size: 13px;
    }

    .card-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        padding-top: 8px;
    }

    .card-actions button {
        background: none;
        border: none;
        color: #555;
        font-size: 18px;
        cursor: pointer;
    }

    .resupply-alert {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;
        border-radius: 8px;
    }
}
</style>
